/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { useRef } from 'react';
import { each } from 'lodash';
import { LinkButton, UploadFileFn, UploadEventHandler, uploadSingleFile } from '@blend/enterprise-components';
import { BlendBridge } from 'blb-types/blendBridge';

export namespace FileUploader {
  export interface Props extends React.AllHTMLAttributes<HTMLInputElement> {
    allowedFileExtensions?: BlendBridge.AllowedFileExtensions[];
    handleUploadEvent: UploadEventHandler;
    loanId: string;
    uploadFile: UploadFileFn<{ loanId: string }>;
  }
}

export const FileUploader: React.FC<FileUploader.Props> = ({
  id,
  children,
  loanId,
  allowedFileExtensions = ['.png', '.jpg', '.jpeg', '.pdf'],
  handleUploadEvent,
  uploadFile,
  disabled,
  ...htmlProps
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const uploadFiles = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { files } = e.target;
    each(files, file => uploadSingleFile({ file, handleUploadEvent, otherUploadParams: { loanId }, uploadFile }));
    // https://stackoverflow.com/a/12102992/1870047
    fileInputRef.current!.value = null as any;
  };

  return (
    <LinkButton
      disabled={disabled}
      icon="add"
      id={`${id}-input`}
      inputProps={{
        accept: allowedFileExtensions.join(','),
        disabled,
        onChange: uploadFiles,
        ref: fileInputRef,
        ...htmlProps,
      }}
      label="Add another document"
    />
  );
};
